import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { clearAllFilters } from 'Pods/SearchPage/Store/actions'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import { getFiltersCount } from 'Pods/SearchPage/Store/selectors'

function ResetButton() {
  const activeFiltersCount = useSearchPageStore(state => getFiltersCount(state))
  const hasActiveFilters = activeFiltersCount > 0

  // onClick stays wired even at count 0: the within-results input holds typed text for 400ms
  // before it commits, so a click while the count still reads 0 must still run clearAllFilters -
  // that is what drops the pending commit (Store/actions/keyword.js). The clear actions are
  // idempotent, so an inert click costs nothing.
  return (
    <Button
      type="secondary"
      customClass="filter-wrapper__button filter-wrapper__button--reset"
      onClick={clearAllFilters}
      aria-label={hasActiveFilters ? `Reset filters (${activeFiltersCount})` : 'Reset filters'}
      isActive={hasActiveFilters}
    >
      {hasActiveFilters ? `Reset (${activeFiltersCount})` : 'Reset'}
    </Button>
  )
}

export default ResetButton
